import { Badge } from '@softwaredev_cegeka/stix-core'
import React from 'react'

class DataTableHelpers {
    static renderTableLegend(statusMap) {
        let badges = Object.entries(statusMap).map(([statusName, variant]) => (
            <Badge key={statusName} size="tiny" variant={variant}>
                {statusName}
            </Badge>
        ))
        return <div className="data-table-legend">{badges}</div>
    }
}

export default DataTableHelpers
